module.exports = "<p>\r\n  base-component works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/base/base-component/base-component.component.html
// module id = ./src/app/pages/base/base-component/base-component.component.html
// module chunks = main